    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            variants: [],
        }
    }
    
    const state = getDefaultState()

    const getters = {
        variants: state => {
            return state.variants
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        variants: (state, payload) => {
            state.variants = payload
        },
    }

    const actions = {
       
        getVariants: ({commit}) =>{
            commit('updating', true)
            axiosAuth.get('/variants')
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('variants', res.data)
                    }

                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        },

        postVariant ({commit, dispatch}, payload) {
            commit('updating', true)
            axiosAuth.post('/variants', payload)
                .then(
                    res => {
                        commit('trash', res)
                        commit('updating', false)
                        dispatch('getVariants')
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
                )
        },

        updateVariant: ({commit, dispatch}, payload) => {
            console.log('payload:', payload)
            
            commit('updating', true)
            axiosAuth.patch('/variants/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    dispatch('getMenus')         
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

        deleteVariant: ({commit, dispatch}, payload) => {
            commit('updating', true)
            axiosAuth.delete('/variants/'+ payload._id)
            .then(
                () => {
                    dispatch('getVariants')
                }
              )
            .catch(
                error => {
  
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }